var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,\n      .cls-2,\n      .cls-5 {\n        fill: #fff\n      }\n\n      .cls-1 {\n        opacity: 0\n      }\n\n      .cls-3,\n      .cls-6 {\n        fill: none\n      }\n\n      .cls-3 {\n        stroke: #8f9bb2\n      }\n\n      .cls-4,\n      .cls-5 {\n        stroke: none\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "duplicate",
    transform: "rotate(180 11 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1845",
    d: "M0 0h22v22H0z",
    className: "cls-1",
    "data-name": "Rectangle 1845"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4275",
    "data-name": "Group 4275",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_10",
    className: "cls-2",
    "data-name": "Subtraction 10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8.498H2c-.827 0-1.5-.673-1.5-1.5v-5c0-.827.673-1.5 1.5-1.5h.611v2.409c0 1.378 1.122 2.5 2.5 2.5h1.39v1.591c0 .827-.674 1.5-1.5 1.5z",
    className: "cls-4",
    transform: "translate(1 5.202)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7.998a1 1 0 0 0 1-1V5.907h-.889c-1.654 0-3-1.346-3-3V.998H2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h3m0 1H2c-1.103 0-2-.897-2-2v-5c0-1.103.897-2 2-2H3.11v2.909c0 1.103.897 2 2 2h1.89v2.091c0 1.103-.898 2-2 2z",
    className: "cls-5",
    transform: "translate(1 5.202)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_680",
    className: "cls-3",
    "data-name": "Rectangle 680",
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 11,
    className: "cls-4",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    x: 0.5,
    y: 0.5,
    className: "cls-6",
    rx: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.43e87ad6dbcfed336f13cd9003c0ecf6.svg";
export { ForwardRef as ReactComponent };